module.exports = "<ul *ngIf=\"shouldShowErrors()\">\r\n  <li class=\"help-block m-b-none\" style=\"color: red!important\" *ngFor=\"let error of listOfErrors()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> {{error}}</li>\r\n</ul>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/padriana/gorent-panel/src/app/show-errors-app/show-errors-app.component.html
// module id = ../../../../../src/app/show-errors-app/show-errors-app.component.html
// module chunks = main